module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("header", function() {
    return [_vm._v("default header")]
  }), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle close-cross",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2 pointer"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_vm._v("\n          default body\n        ")]
  })], 2), _vm._v(" "), (_vm.isShowFooter) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "bttn create-btn right marg-10",
    on: {
      "click": function($event) {
        return _vm.$emit('submit')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.submitTxt) + "\n        ")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d6c6e69!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AppModal.vue
// module id = 1623
// module chunks = 1